/**
* MQ - A plugin to help manage media queries
**/
const MQ = {
  install (Vue, options = {}) {
    const queries = options.queries;

    function testKey (key) {
      return queries.hasOwnProperty(key) ? true : false;
    }

    // Within the Vue community, it is generally expected that plugins which 
    // modify the Vue prototype prefix any added properties with a dollar sign ($).
    // this is referred to as an instance method

    // Adding $mq to Vue.prototype allows us to use $mq within Vue as this.$mq()
    Vue.prototype.$mq = function (query) {
      // Usage:
      // Declare media queries with key/value pairs when installing the plugin. E.g.
      // Vue.use(MQ, {
      //   queries: {
      //     'xs-max': '(max-width: 767px)',
      //     'sm-min': '(min-width: 768px)',
      //     'sm-max': '(max-width: 991px)',
      //     'md-min': '(min-width: 992px)',
      //   }
      // });

      // Use within app like
      // this.$mq('xs-max')
      // or for media queries between a range
      // this.$mq('sm-min AND sm-max')
      
      try {
        let thisQuery = null;

        if (query.includes('AND')) {
          const arr = query.split('AND');
          const newArr = [];

          arr.forEach((el, index) => {
            let item = el.trim();

            if (testKey(item)) {
              newArr.push(queries[item]);
            } else {
              throw item;
            }
          });

          thisQuery = newArr.join(' and ');
        } else {
          if (testKey(query)) {
            thisQuery = queries[query];
          } else {
            throw query;
          }
        }

        return window.matchMedia(thisQuery).matches;
      } catch (e) {
        console.error('The media query key: "' + e + '" does not exist.');
        return false;
      }
    } 
  }
};

export default MQ;


// WEBPACK FOOTER //
// ./resources/assets/js/app/plugins/mq/index.js